export default "__VITE_ASSET__DBTc66n0__"